import angular from 'angular';

module.exports = angular.module('market.components.hvr-charts', [
  require('./od-hvr-bar-chart'),
  require('./od-hvr-grouped-bar-chart'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/hvr-charts/index.js
 **/